module.exports = __webpack_public_path__ + "img/test-5-8-3-glitch.ff515f71.png";